module.exports = __webpack_public_path__ + "static/media/Molly Weasley 3.c844002e.jpg";